import { ReactNode } from 'react';

import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

export interface ErrorBoundaryProps {
  fallback: ReactNode;
  children: ReactNode;
}

export const ErrorBoundary = ({ fallback, children }: ErrorBoundaryProps) => {
  return <SentryErrorBoundary fallback={() => <>{fallback}</>}>{children}</SentryErrorBoundary>;
};
